module.exports = __webpack_public_path__ + "img/iconbm.38a8843e.png";